export const IconRoundChat = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M7.171 9.881a1.39 1.39 0 0 0-1.38 1.386c0 .829.617 1.466 1.38 1.466.764 0 1.341-.635 1.341-1.426s-.573-1.426-1.34-1.426m4.83-.04c-.766 0-1.341.635-1.341 1.426s.614 1.386 1.34 1.386 1.342-.635 1.342-1.386S12.768 9.841 12 9.841m4.829.04c-.765 0-1.341.635-1.341 1.426s.614 1.426 1.34 1.426c.766 0 1.38-.635 1.38-1.426 0-.793-.612-1.426-1.38-1.426M12 2C5.905 2 1.002 6.149 1.002 11.267c0 2.122.859 4.066 2.282 5.627-.642 1.76-1.978 3.247-2 3.264a1.1 1.1 0 0 0-.2 1.158c.13.426.5.684.914.684 2.652 0 4.704-1.147 5.998-2.06 1.245.4 2.594.634 4.006.634 6.097 0 10.999-4.149 10.999-9.227C23 6.27 18.098 2 12 2m0 16.436c-1.153 0-2.29-.184-3.378-.54l-.981-.318-.84.613c-.615.45-1.46.952-2.48 1.292.319-.54.62-1.148.857-1.794l.458-1.247-.889-.974c-.775-.86-1.712-2.28-1.712-4.16 0-3.933 4.02-7.13 8.93-7.13 4.909 0 8.93 3.197 8.93 7.13 0 3.931-3.944 7.128-8.894 7.128" />
    </svg>
  );
};
